import React, { PureComponent, Component } from 'react';
import TableRow from './TableRow'

class TableBody extends Component {
    constructor(props) {
        super(props);

    }

    render() {
        const { procesos, routeToEditarConfiguracionProceso, administratorSelected } = this.props;
        let procesosRowTableNodes = null;
        let list = [];
        const idSeleccionado = administratorSelected == 0 ? null : administratorSelected || 1;
        if (procesos && procesos.length > 0) {

            const procesosFiltrados = procesos.filter(x => x.AdministradoraId == idSeleccionado)

            list = JSON.parse(JSON.stringify(procesosFiltrados));
            procesosRowTableNodes = list?.map((row, index) => {  
                let esPar = (index + 1) % 2 == 0;  
                return <TableRow procesos={row} key={index} esPar={esPar} routeToEditarConfiguracionProceso={routeToEditarConfiguracionProceso} />
            })

        }
        return (
            <tbody>
                {procesosRowTableNodes}
            </tbody>
        )
    }
};

export default TableBody;